var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 25,
    viewBox: "0 0 18 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0.455078H3C1.3455 0.455078 0 1.80058 0 3.45508V21.4551C0 23.1096 1.3455 24.4551 3 24.4551H15C16.6545 24.4551 18 23.1096 18 21.4551V3.45508C18 1.80058 16.6545 0.455078 15 0.455078ZM9 21.4551C8.172 21.4551 7.5 20.7831 7.5 19.9551C7.5 19.1271 8.172 18.4551 9 18.4551C9.828 18.4551 10.5 19.1271 10.5 19.9551C10.5 20.7831 9.828 21.4551 9 21.4551ZM15 15.4551H3V3.45508H15V15.4551Z",
    fill: "currentColor"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4815_27027",
    x1: -8.89527e-10,
    y1: 12.4551,
    x2: 17.9694,
    y2: 12.4464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F51919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#770001"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.534a4aee3bccfb7d9c1c0b87b84593c8.svg";
export { ForwardRef as ReactComponent };